import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";

// material-ui
import { useTheme } from "@mui/material/styles";
import { useMediaQuery, Box, Container, Toolbar } from "@mui/material";

// project-imports
import Drawer from "./Drawer";
import Header from "./Header";
import Footer from "./Footer";
import Breadcrumbs from "components/@extended/Breadcrumbs";
import Modals from "./Header/teamsdropdownmodal";

import navigation from "menu-items";
import { dispatch, useSelector } from "store";
import { openDrawer } from "store/reducers/menu";
import { DRAWER_WIDTH } from "config";
import { AES, enc } from "crypto-js";
import * as url from "../../store/constant/Endpoints";
import { FetchAllActivities, FetchAllLeads, FetchAllSelectLeads, GetAllUsers } from "store/action/index";

// ==============================|| MAIN LAYOUT ||============================== //

const MainLayout = () => {
  const theme = useTheme();
  const matchDownLG = useMediaQuery(theme.breakpoints.down("xl"));
  const { drawerOpen } = useSelector((state) => state.menu);
  const [cmpglbmodope, setCmpGlbe] = useState(false);

  // drawer toggler
  const [open, setOpen] = useState(drawerOpen);
  const handleDrawerToggle = () => {
    setOpen(!open);
    dispatch(openDrawer({ drawerOpen: !open }));
  };
  let permissionUser = localStorage.getItem("data");

  let decryptedData = null;
  if (permissionUser) {
    try {
      // Code that may throw an exception
      decryptedData = AES.decrypt(
        permissionUser,
        url.encryptionSecret
      ).toString(enc.Utf8);
      // ...
    } catch (error) {
      localStorage.clear();
      window.location.reload();
    }
  }

  const permissionsAssrray =
    decryptedData && JSON.parse(decryptedData);

  useEffect(() => {
    setOpen(!matchDownLG);
    dispatch(openDrawer({ drawerOpen: !matchDownLG }));
    let params = { team_id: localStorage.getItem("teams_id") }
    let parsssams = { team_id: localStorage.getItem("teams_id"), per_page: "all" }
    dispatch(GetAllUsers({ params: parsssams }))
    dispatch(FetchAllSelectLeads({ params }))

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [matchDownLG]);

  useEffect(() => {
    const teamId = localStorage.getItem("teams_id");
    const isNotSuperAdmin = permissionsAssrray?.role_name !== "super_admin";

    // Show modal if no team is selected AND user is not a super admin
    if (!teamId && isNotSuperAdmin) {
      setCmpGlbe(true);
    }
  }, []);

  // useEffect(() => {
  //   const checkCondition = localStorage.getItem("teams_id");
  //   const hasModalBeenShown = localStorage.getItem("hasModalBeenShown");

  //   if (!checkCondition && permissionsAssrray?.role_name !== "super_admin") {
  //     console.log("CHeckCOnditonsssssss=======>>>>>>>>>>")
  //     setCmpGlbe(true);
  //     localStorage.setItem("hasModalBeenShown", "true");
  //   }

  //   if (!hasModalBeenShown && permissionsAssrray?.role_name !== "super_admin") {
  //     console.log("HasModalBeenSHownnnn=======>>>>>>>>>>")
  //     setCmpGlbe(true);
  //     localStorage.setItem("hasModalBeenShown", "true");
  //   }
  // }, []);

  const handleClose = () => {
    setCmpGlbe(false);
  };

  useEffect(() => {
    if (open !== drawerOpen) setOpen(drawerOpen);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [drawerOpen]);

  // useEffect(() => {
  //   const handleVisibilityChange = () => {
  //     document.title = document.visibilityState === 'visible'
  //       ? 'Property Management'
  //       : 'Come back soon! You’re missed.';
  //   };
  //   document.addEventListener('visibilitychange', handleVisibilityChange);
  //   return () => {
  //     document.removeEventListener('visibilitychange', handleVisibilityChange);
  //   };
  // }, []);


  return (
    <>
      <Box sx={{ display: "flex", width: "100%" }}>
        <Header open={open} handleDrawerToggle={handleDrawerToggle} />
        <Drawer open={open} handleDrawerToggle={handleDrawerToggle} />

        <Box
          component="main"
          sx={{
            width: `calc(100% - ${DRAWER_WIDTH}px)`,
            flexGrow: 1,
            p: { xs: 2, sm: 3 },
          }}
        >
          <Toolbar sx={{ mt: "inherit" }} />
          <Container
            sx={{
              position: "relative",
              minHeight: "calc(100vh - 110px)",
              display: "flex",
              flexDirection: "column",
              maxWidth: "2000px !important",
            }}
          >
            <Breadcrumbs navigation={navigation} title />
            <Outlet />
            <Footer />
          </Container>
        </Box>
      </Box>
      <Modals open={cmpglbmodope} handleClose={handleClose} />
    </>
  );
};

export default MainLayout;
